const mapPinOff = `<svg xmlns="http://www.w3.org/2000/svg" width="36" height="37" viewBox="0 0 36 37" fill="none">
<path d="M17.75 0C8.975 0 2 6.975 2 15.75C2 20.025 3.575 24.075 6.725 27C6.95 27.225 15.95 35.325 16.175 35.55C17.075 36.225 18.425 36.225 19.1 35.55C19.325 35.325 28.55 27.225 28.55 27C31.7 24.075 33.275 20.025 33.275 15.75C33.5 6.975 26.525 0 17.75 0Z" fill="#1e293b"/>
<circle cx="17.5" cy="15.5" r="12.5" fill="#1e293b"/>
<circle cx="17.5" cy="15.5" r="12.5" fill="url(#paint0_radial_2343_66797)"/>
<circle cx="17.5" cy="15.5" r="12" stroke="white" stroke-opacity="0.2" fill="#1e293b"/>
<circle cx="17.5" cy="15.5" r="12" stroke="url(#paint1_linear_2343_66797)" fill="#1e293b"/>
<defs fill="#1e293b">
<radialGradient id="paint0_radial_2343_66797" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(17.5 28) scale(12.5 25)" fill="#1e293b">
<stop stop-color="white" stop-opacity="0.15" fill="#1e293b"/>
<stop offset="1" stop-color="white" stop-opacity="0" fill="#1e293b"/>
</radialGradient>
<linearGradient id="paint1_linear_2343_66797" x1="17.5" y1="3" x2="17.5" y2="28" gradientUnits="userSpaceOnUse" fill="#1e293b">
<stop offset="0.0001" stop-color="white" stop-opacity="0.26" fill="#1e293b"/>
<stop offset="0.9999" stop-color="white" stop-opacity="0" fill="#1e293b"/>
</linearGradient>
</defs>
</svg>`;

const mapPinOn = `<svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.75 0C8.975 0 2 6.975 2 15.75C2 20.025 3.575 24.075 6.725 27C6.95 27.225 15.95 35.325 16.175 35.55C17.075 36.225 18.425 36.225 19.1 35.55C19.325 35.325 28.55 27.225 28.55 27C31.7 24.075 33.275 20.025 33.275 15.75C33.5 6.975 26.525 0 17.75 0Z" fill="#357D42"/>
<circle cx="17.5" cy="15.5" r="12.5" fill="#357D42"/>
<circle cx="17.5" cy="15.5" r="12.5" fill="url(#paint0_radial_2343_66797)"/>
<circle cx="17.5" cy="15.5" r="12" stroke="white" stroke-opacity="0.2"/>
<circle cx="17.5" cy="15.5" r="12" stroke="url(#paint1_linear_2343_66797)"/>
<defs>
<radialGradient id="paint0_radial_2343_66797" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(17.5 28) scale(12.5 25)">
<stop stop-color="white" stop-opacity="0.15"/>
<stop offset="1" stop-color="white" stop-opacity="0"/>
</radialGradient>
<linearGradient id="paint1_linear_2343_66797" x1="17.5" y1="3" x2="17.5" y2="28" gradientUnits="userSpaceOnUse">
<stop offset="0.0001" stop-color="white" stop-opacity="0.26"/>
<stop offset="0.9999" stop-color="white" stop-opacity="0"/>
</linearGradient>
</defs>
</svg>`;

const mapPinShadowOff = `<svg width="44" height="45" viewBox="0 0 44 45" fill="none" xmlns="http://www.w3.org/2000/svg">
<g opacity="0.6" filter="url(#filter0_f_2343_66850)">
<ellipse cx="22" cy="40" rx="20" ry="4" fill="url(#paint0_radial_2343_66850)"/>
</g>
<path d="M21.75 4C12.975 4 6 10.975 6 19.75C6 24.025 7.575 28.075 10.725 31C10.95 31.225 19.95 39.325 20.175 39.55C21.075 40.225 22.425 40.225 23.1 39.55C23.325 39.325 32.55 31.225 32.55 31C35.7 28.075 37.275 24.025 37.275 19.75C37.5 10.975 30.525 4 21.75 4Z" fill="#357D42"/>
<circle cx="21.5" cy="19.5" r="12.5" fill="#357D42"/>
<circle cx="21.5" cy="19.5" r="12.5" fill="url(#paint1_radial_2343_66850)"/>
<circle cx="21.5" cy="19.5" r="12" stroke="white" stroke-opacity="0.2"/>
<circle cx="21.5" cy="19.5" r="12" stroke="url(#paint2_linear_2343_66850)"/>
<defs>
<filter id="filter0_f_2343_66850" x="1" y="35" width="42" height="10" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_2343_66850"/>
</filter>
<radialGradient id="paint0_radial_2343_66850" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(22 40) rotate(90) scale(4 20)">
<stop/>
<stop offset="0.5" stop-opacity="0.23"/>
<stop offset="1" stop-opacity="0"/>
</radialGradient>
<radialGradient id="paint1_radial_2343_66850" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(21.5 32) scale(12.5 25)">
<stop stop-color="white" stop-opacity="0.15"/>
<stop offset="1" stop-color="white" stop-opacity="0"/>
</radialGradient>
<linearGradient id="paint2_linear_2343_66850" x1="21.5" y1="7" x2="21.5" y2="32" gradientUnits="userSpaceOnUse">
<stop offset="0.0001" stop-color="white" stop-opacity="0.26"/>
<stop offset="0.9999" stop-color="white" stop-opacity="0"/>
</linearGradient>
</defs>
</svg>`;

const mapPinShadowOn = `<svg width="44" height="45" viewBox="0 0 44 45" fill="none" xmlns="http://www.w3.org/2000/svg">
<g opacity="0.6" filter="url(#filter0_f_2343_66851)">
<ellipse cx="22" cy="40" rx="20" ry="4" fill="url(#paint0_radial_2343_66851)"/>
</g>
<path d="M21.75 4C12.975 4 6 10.975 6 19.75C6 24.025 7.575 28.075 10.725 31C10.95 31.225 19.95 39.325 20.175 39.55C21.075 40.225 22.425 40.225 23.1 39.55C23.325 39.325 32.55 31.225 32.55 31C35.7 28.075 37.275 24.025 37.275 19.75C37.5 10.975 30.525 4 21.75 4Z" fill="#357D42"/>
<circle cx="21.5" cy="19.5" r="12.5" fill="black" fill-opacity="0.2"/>
<circle cx="21.5" cy="19.5" r="12.5" fill="url(#paint1_linear_2343_66851)"/>
<circle cx="21.5" cy="19.5" r="13" stroke="black" stroke-opacity="0.1"/>
<circle cx="21.5" cy="19.5" r="12" stroke="url(#paint2_linear_2343_66851)"/>
<path d="M21.0002 23C20.7442 23 20.4883 22.902 20.2933 22.707L18.2932 20.707C17.9022 20.316 17.9022 19.684 18.2932 19.293C18.6842 18.902 19.3162 18.902 19.7072 19.293L21.0002 20.586L24.2933 17.293C24.6843 16.902 25.3162 16.902 25.7072 17.293C26.0982 17.684 26.0982 18.316 25.7072 18.707L21.7072 22.707C21.5122 22.902 21.2562 23 21.0002 23Z" fill="white"/>
<defs>
<filter id="filter0_f_2343_66851" x="1" y="35" width="42" height="10" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="0.5" result="effect1_foregroundBlur_2343_66851"/>
</filter>
<radialGradient id="paint0_radial_2343_66851" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(22 40) rotate(90) scale(4 20)">
<stop/>
<stop offset="0.5" stop-opacity="0.23"/>
<stop offset="1" stop-opacity="0"/>
</radialGradient>
<linearGradient id="paint1_linear_2343_66851" x1="21.5" y1="7" x2="21.5" y2="32" gradientUnits="userSpaceOnUse">
<stop stop-opacity="0.3"/>
<stop offset="1" stop-opacity="0"/>
</linearGradient>
<linearGradient id="paint2_linear_2343_66851" x1="21.5" y1="7" x2="21.5" y2="32" gradientUnits="userSpaceOnUse">
<stop offset="0.0001" stop-color="white" stop-opacity="0.55"/>
<stop offset="0.9999" stop-color="white" stop-opacity="0.2"/>
</linearGradient>
</defs>
</svg>`;

export { mapPinOff, mapPinOn, mapPinShadowOn, mapPinShadowOff };
